import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { SchedulerTaskOrderField } from '../scheduler-task-order-field';

export class SchedulerTaskOrderFieldBuilder {
  static fromJson(json) {
    return (json)
      ? new SchedulerTaskOrderField(
        parseNumber(json.code),
        json.display,
        json.dataField
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(SchedulerTaskOrderFieldBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/scheduler-task-order-field.builder.ts